import isNode from '../../is-node';
import { useRouterHistory } from 'react-router';
import { createMemoryHistory, createHistory } from 'history';
import qs from 'qs';

// Set up a custom history to handle array params correctly, ex: ?condition[]=used
const stringifyQuery = query => qs.stringify(query, { arrayFormat: 'brackets', encodeValuesOnly: true });
const history = isNode ? createMemoryHistory : createHistory;

// This is not actually a React hook, but it starts with "use", so eslint thinks it is
// eslint-disable-next-line
const routerHistory = useRouterHistory<any, {}>(history)({
  stringifyQuery,
  parseQueryString: qs.parse,
});

export default routerHistory;
